module.exports = __webpack_public_path__ + "static/media/covid19-mobile-en.6df1db69.jpg";